import React from 'react';
import './OverrideBadge.css';

/**
 * Compact status dot.
 * - override (amber): saved value differs from build / system default
 * - default (slate): build / system baseline
 * Full meaning lives in legends at the top of each card.
 */
export default function OverrideBadge({
  kind = 'override',
  title,
  className = '',
}) {
  const isDefault = kind === 'default';
  const resolvedTitle =
    title ||
    (isDefault ? 'Build / system default' : 'Saved value differs from default');

  return (
    <span
      className={[
        'override-badge',
        isDefault ? 'override-badge-default' : null,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      title={resolvedTitle}
      aria-label={resolvedTitle}
    />
  );
}

export function OverrideBadgeLegend({
  text = 'Saved value differs from default',
  className = '',
}) {
  return (
    <div
      className={['override-badge-legend', className].filter(Boolean).join(' ')}
      aria-label="Override legend"
    >
      <OverrideBadge />
      <span className="override-badge-legend-text">{text}</span>
    </div>
  );
}
